import { render, staticRenderFns } from "./OrderFormNow.vue?vue&type=template&id=37f04cee&"
import script from "./OrderFormNow.vue?vue&type=script&lang=js&"
export * from "./OrderFormNow.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormNow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports